import { Breadcrumb } from 'antd';
import React from 'react';

const MemberAddress: React.FC = () => (
  <Breadcrumb style={{marginTop:'18px',fontSize:'16px',marginBottom:'11px'}} separator=">">
     <Breadcrumb.Item> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '主頁' : '主页'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '時事評論' : '时事评论'}</Breadcrumb.Item>
 
  </Breadcrumb>
);

export default MemberAddress;